import { axiosClient } from "../client";
const queryString = require("query-string");

// API endpoints
const API_GET_MODIFIER_GROUP_LIST = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifierGroup`;

const API_UPDATE_MODIFIER_GROUP = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifierGroup`;

const API_CREATE_MODIFIER_GROUP = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifierGroup`;

const API_UPDATE_MODIFIER = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifier`;

const API_CREATE_MODIFIER = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifier`;

const API_GET_MODIFIER = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifier`;

const API_DELETE_MODIFIER = (locationId, modifierId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/modifier/id/${modifierId}`;


// Get modifier group list
export const fetchModifierGroupList = (
  locationId,
  token,
) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: API_GET_MODIFIER_GROUP_LIST(locationId),
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

// Create new modifier group
export const createModifierGroup = (
  locationId,
  data,
  token,
) =>
  axiosClient({
    method: "POST",
    url: API_CREATE_MODIFIER_GROUP(locationId),
    data: data, // Pass data directly
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

// Update modifier group (PATCH)
export const updateModifierGroup = (
  locationId,
  data,
  token,
) =>
  axiosClient({
    method: "PATCH",
    url: API_UPDATE_MODIFIER_GROUP(locationId),
    data: data, // Pass data directly
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  // Create new modifier group
export const createModifier = (
  locationId,
  data,
  token,
) =>
  axiosClient({
    method: "POST",
    url: API_CREATE_MODIFIER(locationId),
    data: data, // Pass data directly
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

// Update modifier group (PATCH)
export const updateModifier = (
  locationId,
  data,
  token,
) =>
  axiosClient({
    method: "PATCH",
    url: API_UPDATE_MODIFIER(locationId),
    data: data, // Pass data directly
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  // Get modifier group list
export const fetchModifier = (
  locationId,
  token,
) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: API_GET_MODIFIER(locationId),
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  export const deleteModifier = (locationId, id) =>
    axiosClient({
      method: "DELETE",
      url: queryString.stringifyUrl(
        {
          url: API_DELETE_MODIFIER(locationId, id),
        },
        {
          sort: false,
          arrayFormat: "comma",
          skipNull: true,
          skipEmptyString: true,
        },
      ),
    });